import { useRef } from 'react';
import { useOutletContext } from 'react-router-dom';
import { MembershipDetailsCard } from '../../../components/MembershipDetailsCard';
import { ErrorFallback } from '../../../components/QueryResults/ErrorFallback';
import { SingleQueryResults } from '../../../components/QueryResults/SingleQueryResults';
import { WorkspaceDetailsForm } from '../../../forms/workspaceDetails/WorkspaceDetailsForm';
import { useActiveWorkspace } from '../../../hooks/useActiveWorkspace';
import { WorkspaceSettingsOutletContext } from '../../../layout/WorkspaceSettingsLayout';

export const Details = () => {
  const [, activeWorkspaceQuery] = useActiveWorkspace();
  const { registerDetailsReset } =
    useOutletContext<WorkspaceSettingsOutletContext>();
  const highlightEmptyDetails = useRef<() => void>();

  return (
    <SingleQueryResults
      errorFallback={(error) => <ErrorFallback error={error} />}
      query={activeWorkspaceQuery}
    >
      {(workspace) => (
        <div className="space-y-8">
          <MembershipDetailsCard
            onHighlightEmptyDetails={() => highlightEmptyDetails.current?.()}
          />

          <WorkspaceDetailsForm
            workspace={workspace}
            onHighlightEmptyDetailsReady={(highlight) => {
              highlightEmptyDetails.current = highlight;
            }}
            onResetReady={registerDetailsReset}
          />
        </div>
      )}
    </SingleQueryResults>
  );
};
